<div class="login-area">
  <div class="login-container element-column">
    <img class="logo" alt="logo" src="/assets/img/peace_logo_yoko.png" />

    <div class="login-content">
      <div class="login-detail element-column">
        <div class="column-list">
          <label class="list-input-title">ユーザID</label>
          <div class="list-input-content">
            <input type="text" id="tbx_user" class="userid" #tbx_user [maxlength]="256" plessInputTextSub
              [restrict]="'[a-zA-Z0-9@!#&amp;$%\'*+\-/=?\^_`\{\|\}~.]'" ime-mode="disabled" [(ngModel)]="kymw1000Model.user" [autofocus]="true"
              (keydown.enter)="eventloginHandler($event)" [tabindex]="0" autocomplete="off" />
          </div>
          <label class="list-input-title">パスワード</label>
          <div class="list-input-content">
            <input type="password" id="tbx_pass" [maxlength]="30" plessInputTextSub
              [restrict]="'[ -￮]'" ime-mode="disabled" [(ngModel)]="kymw1000Model.pass"
              (keydown.enter)="eventloginHandler($event)" [tabindex]="0" style="width: 37rem;"
              autocomplete="off" />
          </div>
        </div>
        <div class="element-column">
          <a (click)="eventPasswordResetHandler()" class="login-link">パスワードをお忘れの方</a>
          <a (click)="eventCallSamlAuthorizeHandler()" class="login-link">コープデリ職員の方はこちらからログイン</a>
        </div>
      </div>
      <div class="layout_end">
        <button class="left-button" id="btn_login" class="btn-primary"
          (click)="eventloginHandler(null)" [tabindex]="0" >ログイン
        </button>
      </div>
    </div>
  </div>
</div>
